import { adminActionTypes } from "src/action_types/section_action_types";

export function selectRiskAlertRulesTablePageLimitAction(limit) {
  return {
    type: adminActionTypes.selectRiskAlertRulesTablePageLimit,
    payload: limit
  };
}
